import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { RegalKontrollePage } from '../pages/regal-kontrolle/regal-kontrolle';
import { HelperProvider } from '../providers/helper-service';
import { ServerProvider } from '../providers/rest-server/server-provider';
import { DemoBarcodesPage } from '../providers/scan-provider/demo-barcodes';
import { ScanProvider } from '../providers/scan-provider/scan-provider';
import { MyApp } from './app.component';

@NgModule({
    declarations: [
        MyApp,
        RegalKontrollePage,
        DemoBarcodesPage
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(MyApp),
        HttpClientModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        RegalKontrollePage,
        DemoBarcodesPage
    ],
    providers: [
        StatusBar,
        SplashScreen,
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        BarcodeScanner,
        ScanProvider,
        ServerProvider,
        HelperProvider
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts